import React from "react";
//icons
import { Icon } from "@iconify/react";
import { Box, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { trackMenuSelection } from "../../helpers/analytics";
import { recordMenuVisit } from "../../helpers/menuStorage";

const MenuList = ({ data, drawerOpen, onClickMenuItem }) => {
  const { userData } = useSelector((state) => state.authReducer);

  const t = useTheme()

  const toggleSubMenu = (e) => {
    e.stopPropagation();

    let subMenu = e.target.nextSibling;

    if (!subMenu || !subMenu.style.display) return;
    if (subMenu?.style?.display === "none" || !subMenu.style.display) {
      e.target.setAttribute("aria-expanded", "true");
      subMenu.style.display = "block";
    } else {
      e.target.setAttribute("aria-expanded", "false");
      subMenu.style.display = "none";
    }
  };

  const handleOnClickMenu = (pagina) => {
    trackMenuSelection(pagina.nombre, pagina.idMenu);
    recordMenuVisit(pagina.idMenu, userData?.preferred_username);
    if (pagina.external) {
      window.open(
        `${pagina.url}username=${userData.preferred_username}&accesstoken=${process.env.REACT_APP_LEVEGES_TOKEN}`,
        pagina.target
      );
    } else {
      onClickMenuItem(pagina);
    }
  };

  const renderMenuIconItem = (item, size = 24) => {
    if (!item) return <Icon icon="solar:widget-3-outline" style={{ fontSize: size }} />;
    const rawIcon = item.icono ? String(item.icono).replace(/[\r\n]+/g, '').trim() : '';
    if (!rawIcon) return <Icon icon="solar:widget-3-outline" style={{ fontSize: size }} />;
    if (rawIcon.startsWith('icon-') || item.iconify === false) {
      return <span className={rawIcon} style={{ fontSize: size }}></span>;
    }
    return <Icon icon={rawIcon} style={{ fontSize: size }} />;
  };

  const renderSubMenu = (subMenu, paddingLevel = 0, isMarketing = false) => {
    return (
      <ul
        style={{ display: "none", paddingLeft: drawerOpen ? paddingLevel : 0 }}
      >
        {subMenu?.map((subItem, index) => {
          const isMarketingSubItem = isMarketing || subItem.nombre === "Marketing";
          const marketingBg = isMarketingSubItem ? (t.palette.mode === 'dark' ? '#3d240d' : '#feeed7') : 'transparent';
          return (
            <li
              key={index}
              onClick={
                subItem.menus ? toggleSubMenu : () => handleOnClickMenu(subItem)
              }
              className="sidebar-item"
            >
              <Box
                sx={{
                  backgroundColor: marketingBg,
                  borderRadius: isMarketingSubItem ? "16px" : "0px",
                  overflow: "hidden"
                }}
              >
                {!drawerOpen ? (
                  <Box
                    className={`sidebar-link`}
                    aria-expanded="false"
                    sx={{
                      justifyContent: "center"
                    }}
                    color={t.palette.mode === 'dark' ? '#fff' : '#666666'}
                  >
                    {renderMenuIconItem(subItem, 24)}
                  </Box>
                ) : (
                  <Box
                    className={`sidebar-link ${subItem.menus && "has-arrow"}`}
                    color={t.palette.mode === 'dark' ? '#ffffff' : '#666666'}
                  >
                    {renderMenuIconItem(subItem, 24)}
                    {subItem.nombre}
                  </Box>
                )}
                {subItem.menus && renderSubMenu(subItem.menus, paddingLevel + 14, isMarketingSubItem)}
              </Box>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className="sidebar-nav scroll-sidebar " style={{ overflowY: 'auto', overflowX: 'hidden', height: '100%' }}>
      <ul>
        {data?.map((item, index) => {
          const isMarketingItem = item.nombre === "Marketing";
          const marketingBg = isMarketingItem ? (t.palette.mode === 'dark' ? '#3d240d' : '#feeed7') : 'transparent';
          return (
            <li
              key={index}
              onClick={item.menus ? toggleSubMenu : () => handleOnClickMenu(item)}
              className="sidebar-item "
            >
              <Box
                sx={{
                  backgroundColor: marketingBg,
                  borderRadius: isMarketingItem ? "16px" : "0px",
                  overflow: "hidden"
                }}
              >
                {!drawerOpen ? (
                  <Box
                    className={`sidebar-link`}
                    aria-expanded="false"
                    sx={{
                      justifyContent: "center"
                    }}
                    color={t.palette.mode === 'dark' ? '#fff' : '#666666'}
                  >
                    {renderMenuIconItem(item, 24)}
                  </Box>
                ) : (
                  <Box
                    className={`sidebar-link ${item.menus && "has-arrow"}`}
                    aria-expanded="false"
                    color={t.palette.mode === 'dark' ? '#ffffff' : '#666666'}
                  >
                    {renderMenuIconItem(item, 24)}
                    {item.nombre}
                  </Box>
                )}

                {item.menus && renderSubMenu(item.menus, 14, isMarketingItem)}
              </Box>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MenuList;
